<app-base-page-template>
  <app-base-page-content-template>
    <app-business-files-grid
      title="Files"
      [classification]="classification">
    </app-business-files-grid>
  </app-base-page-content-template>
</app-base-page-template>
